module.exports = __webpack_public_path__ + "img/polygon-review.34fc5173.svg";